/* eslint-disable */
//TODO eslint отключен, нужен рефакторинг

import * as React from "react";
import { findDOMNode } from "react-dom";

export function isRecaptchaAvailable(): boolean {
  return !!window.grecaptcha && !!window.grecaptcha.render;
}

export function renderRecaptcha(
  container: Element,
  parameters: IRecaptchaRenderParemeters
) {
  if (isRecaptchaAvailable()) {
    window.grecaptcha.render(container, parameters);
  } else {
    window.setTimeout(() => renderRecaptcha(container, parameters), 200);
  }
}

export interface IRecaptchaProps {
  onExpired?(): void;
  onExecute?(response: string): void;
  sitekey: string;
  theme?: "dark" | "light";
  type?: "audio" | "image";
  size?: "compact" | "normal";
  tabindex?: number;
}

export class Recaptcha extends React.Component<IRecaptchaProps, {}> {
  public componentDidMount() {
    const {
      sitekey,
      theme,
      type,
      size,
      tabindex,
      onExecute,
      onExpired
    } = this.props;
    const node = findDOMNode(this);

    renderRecaptcha(node as Element, {
      callback: onExecute,
      "expired-callback": onExpired,
      sitekey,
      size,
      tabindex,
      theme,
      type
    });
  }

  public render() {
    return <div style={{ width: 304 }} />;
  }
}
